import React from 'react';
import { observer } from 'mobx-react-lite';
import { ChecklistCard, ChecklistOption, EnrollmentStage } from 'types/enrollmentService';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import OptionCard from '../OptionCard';
import { StagesSectionStyled } from './styles';

interface Props {
  options: ChecklistOption<ChecklistCard>[];
  enrollmentPeriodId?: string;
  enrollmentStage?: EnrollmentStage;
  groupId?: string;
  cartId?: string;
  isLoading: boolean;
}

/**
 * @deprecated: Use StepCard component instead.
 */
const OptionList: React.FC<Props> = observer(
  ({ options, enrollmentPeriodId, enrollmentStage, groupId, cartId, isLoading }) => {
    return (
      <StagesSectionStyled>
        {!isLoading && enrollmentPeriodId
          ? options.map((option) => (
              <OptionCard
                option={option}
                enrollmentPeriodId={enrollmentPeriodId}
                enrollmentStage={enrollmentStage!}
                groupId={groupId!}
                cartId={cartId}
                key={`${option.card}_${option.completionStatus}`}
              />
            ))
          : null}
        <OverlaySpinner display={isLoading} />
      </StagesSectionStyled>
    );
  },
);

export default OptionList;
